import { render } from "./ImportStats.vue?vue&type=template&id=6815f73e"
import script from "./ImportStats.vue?vue&type=script&lang=js"
export * from "./ImportStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__